import { render } from "./LoadingSpinner.vue?vue&type=template&id=4cc4934a&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=4cc4934a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc4934a"]])

export default __exports__